import { Map } from 'immutable';
import Constants from '../../constants/index';
import { commonReducerCreator } from '../helpers/index';

export const DEFAULT_STATE = Map({
	result: 'recent',
});

const filter = commonReducerCreator(Constants.FILTER, true, DEFAULT_STATE);

export default filter;
